export function removeItem(storage) {
  return function execute(key) {
    storage.removeItem(key);
  };
}

export default removeItem(window.localStorage);
